export enum Interface {
  INavigation = 'INavigation',
  IDialog = 'IDialog',
  ITouch = 'ITouch',
  IDebug = 'IDebug',
  ISize = 'ISize',
  IAssets = 'IAssets',
  ISound = 'ISound',
  IWalletFaces = 'IWalletFaces'
}
